import { jsxs as P, jsx as n, Fragment as J } from "react/jsx-runtime";
import { u as K, a as Q, b as D, c as W, d as X, e as Y, s as Z, f as _, g as $, h as T, i as ee, j as ne, k as se, F as te, l as oe, m as ae, n as ie, o as le, p as de, q as re, r as ce, t as ue, v as fe } from "../../floating-ui.react-K1eW_SJH.js";
import { forwardRef as E, useState as F, useRef as C, useContext as me, useEffect as k, cloneElement as pe, isValidElement as ve } from "react";
import { MenuContext as M } from "./context.js";
import { s as I } from "../../Dropdown.module-CFFK1Ien.js";
import he from "../icon/Icon.js";
import Fe from "classnames";
const g = E(
  ({ children: r, label: c, customTrigger: s, ...u }, O) => {
    const [o, m] = F(!1), [j, x] = F(!1), [p, v] = F(null), N = C([]), b = C([]), h = me(M), t = K(), i = Q(), l = D(), w = W(), e = l != null, { floatingStyles: A, refs: R, context: a } = X({
      nodeId: i,
      open: o,
      onOpenChange: m,
      placement: e ? "right-start" : "bottom-start",
      middleware: [ce({ mainAxis: e ? 0 : 4, alignmentAxis: e ? -4 : 0 }), ue(), fe()],
      whileElementsMounted: re
    }), H = Y(a, {
      enabled: e,
      delay: { open: 75 },
      handleClose: Z({ blockPointerEvents: !0 })
    }), L = _(a, {
      event: "mousedown",
      toggle: !e,
      ignoreMouse: e
    }), S = $(a, { role: "menu" }), q = T(a, { bubbles: !0 }), z = ee(a, {
      listRef: N,
      activeIndex: p,
      nested: e,
      onNavigate: v
    }), U = ne(a, {
      listRef: b,
      onMatch: o ? v : void 0,
      activeIndex: p
    }), { getReferenceProps: V, getFloatingProps: B, getItemProps: G } = se([H, L, S, q, z, U]);
    return k(() => {
      if (!t) return;
      function f() {
        m(!1);
      }
      function d(y) {
        y.nodeId !== i && y.parentId === l && m(!1);
      }
      return t.events.on("click", f), t.events.on("menuopen", d), () => {
        t.events.off("click", f), t.events.off("menuopen", d);
      };
    }, [t, i, l]), k(() => {
      o && t && t.events.emit("menuopen", { parentId: l, nodeId: i });
    }, [t, o, i, l]), /* @__PURE__ */ P(te, { id: i, children: [
      pe(
        ve(s) ? s : /* @__PURE__ */ n("button", {}),
        {
          ref: oe([R.setReference, w.ref, O]),
          tabIndex: e ? h.activeIndex === w.index ? 0 : -1 : void 0,
          role: e ? "menuitem" : void 0,
          "data-open": o ? "" : void 0,
          "data-nested": e ? "" : void 0,
          "data-focus-inside": j ? "" : void 0,
          className: Fe(s == null ? void 0 : s.props.className, {
            [I["dropdown-item"]]: e,
            [I["dropdown-trigger"]]: !e && !s
          }),
          ...V(
            h.getItemProps({
              ...u,
              onFocus(f) {
                var d;
                (d = u.onFocus) == null || d.call(u, f), x(!1), h.setHasFocusInside(!0);
              }
            })
          )
        },
        s ? s.props.children : /* @__PURE__ */ P(J, { children: [
          c,
          e && /* @__PURE__ */ n(he, { name: "chevronRight", size: 16 })
        ] })
      ),
      /* @__PURE__ */ n(
        M.Provider,
        {
          value: {
            activeIndex: p,
            setActiveIndex: v,
            getItemProps: G,
            setHasFocusInside: x,
            isOpen: o
          },
          children: /* @__PURE__ */ n(ae, { elementsRef: N, labelsRef: b, children: o && /* @__PURE__ */ n(ie, { children: /* @__PURE__ */ n(le, { context: a, modal: !1, initialFocus: e ? -1 : 0, returnFocus: !e, children: /* @__PURE__ */ n("div", { ref: R.setFloating, className: I.dropdown, style: A, ...B(), children: r }) }) }) })
        }
      )
    ] });
  }
), Ie = E((r, c) => D() === null ? /* @__PURE__ */ n(de, { children: /* @__PURE__ */ n(g, { ...r, ref: c }) }) : /* @__PURE__ */ n(g, { ...r, ref: c }));
Ie.displayName = "Dropdown";
g.displayName = "DropdownComponent";
export {
  Ie as default
};
